module.exports = __webpack_public_path__ + "img/product-20.0586e249.jpg";